$(document).ready(function(){ 
var cartDrawerContent = document.getElementsByClassName('ebcf_line_items')[0];  
var ebModal = document.getElementById('mySizeChartModal');
var ebSpan = document.getElementsByClassName("ebcf_close")[0];

// When the user clicks the button, open the modal 
/*ebBtn.onclick = function() {
    ebModal.style.display = "block";
}*/

// When the user clicks on <span> (x), close the modal
ebSpan.onclick = function() {
    $("#mySizeChartModal").removeClass('active-modal');
    ebModal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == ebModal) {
        $("#mySizeChartModal").removeClass('active-modal');
        ebModal.style.display = "none";
    }
}

$(document).on('click', '.cont_shop', function() {
      $("#mySizeChartModal").removeClass('active-modal');
        ebModal.style.display = "none";
});
  
  $('#div2').hide();
  $('.sub_cart_area').hide();

  var current_url = window.location.href;

  // Count the number of question marks in the URL
    var questionMarkCount = (current_url.match(/\?/g) || []).length;

    if (questionMarkCount > 1) {
        // Replace the last question mark with an ampersand
        var indexOfLastQuestionMark = current_url.lastIndexOf('?');
        var modifiedUrl = current_url.substring(0, indexOfLastQuestionMark) + '&' + current_url.substring(indexOfLastQuestionMark + 1);
        window.history.replaceState(null, null, modifiedUrl);
        console.log("Modified URL:", modifiedUrl);
        var url_current = 'variant';
  //if(current_url.indexOf('?' + url_current + '=') != -1 )
  var params = new URLSearchParams(window.location.search);
  if (params.has('variant'))
     {
       //alert('hi');
       console.log('Hi');
       let get_variant = getUrlVars()["variant"];
       console.log('current variant'+get_variant);
       $('.product_box_area').removeClass('selected_box');
       let product_no = $('.'+ get_variant).attr('prod-no');
        $('.'+ product_no).addClass('selected_box');

        let product_type = $('.'+ get_variant).attr('prod-type');
        if(product_type == 'one_time')
        {
          $('.listing_link').removeClass('active_tab');
          $('.onetime_').addClass('active_tab');
          $('.prdct_tab').hide();
          $('.one_time_purchase_area').show();
          $('.sub_cart_area').hide();
          $('.one_time_cart_area').show();
          $('.sub_cart_btn').removeAttr('id');
          $('.one_time_cart_btn').attr('id', 'new-form-atc');
          //$('#subs_seller_planId').removeAttr('name');
          $('.del-date-drop').hide();
        }
        else
        {
          $('.listing_link').removeClass('active_tab');
          $('.subs_').addClass('active_tab');
          $('.prdct_tab').hide();
          $('.save_and_subscribe_area').show();
          $('.one_time_cart_area').hide();
          $('.sub_cart_area').show();
          $('.one_time_cart_btn').removeAttr('id');
          $('.sub_cart_btn').attr('id', 'new-form-atc');
          //$('#subs_seller_planId').attr('name', 'selling_plan');
          $('.del-date-drop').show();
        }  

        let actual_prc = $('.'+ get_variant).attr('actual-prc');
        let cmp_prc = $('.'+ get_variant).attr('cmp-prc');
        let prod_name = $('.'+ get_variant).attr('prod-name');
        $('.actual_prc').text('$'+actual_prc);
        $('.cmpr-prc').text('$'+cmp_prc);
        $('#offer_name').text(prod_name);
     }
     else
     {
        let actual_prc = $('.selected_box').attr('actual-prc');
        let cmp_prc = $('.selected_box').attr('cmp-prc');
        let prod_name = $('.selected_box').attr('prod-name');
        $('.actual_prc').text('$'+actual_prc);
        $('.cmpr-prc').text('$'+cmp_prc);
        $('#offer_name').text(prod_name);
     }
    } else {
        console.log("The URL has fewer than two question marks.");
       var url_current = 'variant';
  //if(current_url.indexOf('?' + url_current + '=') != -1 )
  var params = new URLSearchParams(window.location.search);
  if (params.has('variant'))
     {
       //alert('hi');
       console.log('Hi');
       let get_variant = getUrlVars()["variant"];
       console.log('current variant'+get_variant);
       $('.product_box_area').removeClass('selected_box');
       let product_no = $('.'+ get_variant).attr('prod-no');
        $('.'+ product_no).addClass('selected_box');

        let product_type = $('.'+ get_variant).attr('prod-type');
        if(product_type == 'one_time')
        {
          $('.listing_link').removeClass('active_tab');
          $('.onetime_').addClass('active_tab');
          $('.prdct_tab').hide();
          $('.one_time_purchase_area').show();
          $('.sub_cart_area').hide();
          $('.one_time_cart_area').show();
          $('.sub_cart_btn').removeAttr('id');
          $('.one_time_cart_btn').attr('id', 'new-form-atc');
          //$('#subs_seller_planId').removeAttr('name');
          $('.del-date-drop').hide();
        }
        else
        {
          $('.listing_link').removeClass('active_tab');
          $('.subs_').addClass('active_tab');
          $('.prdct_tab').hide();
          $('.save_and_subscribe_area').show();
          $('.one_time_cart_area').hide();
          $('.sub_cart_area').show();
          $('.one_time_cart_btn').removeAttr('id');
          $('.sub_cart_btn').attr('id', 'new-form-atc');
          //$('#subs_seller_planId').attr('name', 'selling_plan');
          $('.del-date-drop').show();
        }  

        let actual_prc = $('.'+ get_variant).attr('actual-prc');
        let cmp_prc = $('.'+ get_variant).attr('cmp-prc');
        let prod_name = $('.'+ get_variant).attr('prod-name');
        $('.actual_prc').text('$'+actual_prc);
        $('.cmpr-prc').text('$'+cmp_prc);
        $('#offer_name').text(prod_name);
     }
     else
     {
        let actual_prc = $('.selected_box').attr('actual-prc');
        let cmp_prc = $('.selected_box').attr('cmp-prc');
        let prod_name = $('.selected_box').attr('prod-name');
        $('.actual_prc').text('$'+actual_prc);
        $('.cmpr-prc').text('$'+cmp_prc);
        $('#offer_name').text(prod_name);
     }
    }
  
  

  //var seller_id = $('.seller_plan').val();
  //localStorage.setItem("seller_id", seller_id);
  
  $('.product_box_area').click(function(e) {
        $('.product_box_area').removeClass('selected_box');
        //$(this).addClass('selected_box');
        var prod_no = $(this).attr('prod-no');
        $('.'+ prod_no).addClass('selected_box');
        let actual_price = $(this).attr('actual-prc');
        let comp_prc = $(this).attr('cmp-prc');
        $('.actual_prc').text('$'+actual_price);
        $('.cmpr-prc').text('$'+comp_prc);
        var prod_nam = $(this).attr('prod-name');
        $('#offer_name').text(prod_nam);

        var var_image = $(this).attr('img-id');
        $('.product-single__thumbnail').removeClass('active-thumb');
        $('.product-single__thumbnail').each(function() {
          var img_src = $(this).attr('data-thumbnail-id');
          if ( img_src == var_image) {
            $(this).addClass('active-thumb');
          }
        });

        
        $('.product-single__photo--has-thumbnails').each(function() {
          var zoom_img_src = $(this).attr('data-image-id');
          if ( zoom_img_src == var_image) {
            $('.product-single__photo--has-thumbnails').addClass('hide');
            $(this).removeClass('hide');
          }
        });

        var crnt_varriant_id = $(this).attr('variant-id');
        changeurl(crnt_varriant_id);
        $('#SingleOptionSelector-1').val(prod_nam);
        $(".abcd option[value='"+crnt_varriant_id+"']").prop("selected", true);
  });
  
  (function() {
    $('.listing_link').click(function(e) {
        $('.prdct_tab').hide();
        $('#' + $(this).attr('title')).show();
        $('.listing_link').removeClass('active_tab');
        $(this).addClass('active_tab');
        var purchase_type = $(this).attr('data-val');
        if(purchase_type == 'one-time')
        {
           //alert($('.onetime').find('.selected_box').attr("actual-prc"));

            $(".onetime").each(function(){ 
              if($(this).hasClass("selected_box")) { 
                let ac_prc = $(this).attr("actual-prc");
                let cm_prc = $(this).attr("cmp-prc");
                $('.actual_prc').text('$'+ac_prc);
                $('.cmpr-prc').text('$'+cm_prc);
                var one_time_crnt_varrnt_id = $(this).attr('variant-id');
                changeurl(one_time_crnt_varrnt_id);
                $(".abcd option[value='"+one_time_crnt_varrnt_id+"']").prop("selected", true);
              }
            })
            $('.one_time_cart_area').show();
            $('.sub_cart_area').hide();
            $('.sub_cart_btn').removeAttr('id');
            $('.one_time_cart_btn').attr('id', 'new-form-atc');
            $('#SingleOptionSelector-0').val('One Time');
            //$('#subs_seller_planId').removeAttr('name');
            $('.del-date-drop').hide();
        }
        else
        {
           //alert($('.subs').find('.selected_box').attr("actual-prc"));
           $(".subs").each(function(){ 
              if($(this).hasClass("selected_box")) { 
                let ac_prc = $(this).attr("actual-prc");
                let cm_prc = $(this).attr("cmp-prc");
                $('.actual_prc').text('$'+ac_prc);
                $('.cmpr-prc').text('$'+cm_prc);
                var sub_crnt_varrnt_id = $(this).attr('variant-id');
                changeurl(sub_crnt_varrnt_id);
                //$(".abcd").val(sub_crnt_varrnt_id);
                $(".abcd option[value='"+sub_crnt_varrnt_id+"']").prop("selected", true);
              }
            })
            $('.sub_cart_area').show();
            $('.one_time_cart_area').hide();
            $('.one_time_cart_btn').removeAttr('id');
            $('.sub_cart_btn').attr('id', 'new-form-atc');
            $('#SingleOptionSelector-0').val('Subscription');
            //$('#subs_seller_planId').attr('name', 'selling_plan');
            $('.del-date-drop').show();
        }
      
        var type = $(this).data('val');
        /* var seller_id = $('.seller_plan').val();
        localStorage.setItem("product_type", type);
        localStorage.setItem("seller_id", seller_id); */
      
        e.preventDefault();
    });
  })();

  $('.one_time_cart_btn').click(function(e) {

          var onetime_variant_id = '';
        
          $(".onetime").each(function(){ 
              if($(this).hasClass("selected_box")) { 
                onetime_variant_id = $(this).attr("variant-id");
              }
            })

          var data = {
                    "id": onetime_variant_id,
                    "quantity": 1
      		   }
       
          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: data,
              success: function(){ 
                  fetchCart(onetime_variant_id);
                  $("#mySizeChartModal").addClass('active-modal');
                  ebModal.style.display = "block";
                
                  //location.href="/checkout";
              }
          });
  })

  $('.sub_cart_btn').click(function(e) {

          //var selling_plan = localStorage.getItem("seller_id");

          //var selling_plan = $('#subs_seller_planId').val();
          var selling_plan = $('#seller_plan_frequency_id').val();
          
        
          var sub_variant_id = '';
        
          $(".subs").each(function(){ 
              if($(this).hasClass("selected_box")) { 
                sub_variant_id = $(this).attr("variant-id");
              }
            });

         console.log('selling plan:',selling_plan);
  
          var data = {
                    "id": sub_variant_id,
                    "quantity": 1,
                    "selling_plan": selling_plan
      		   }

          console.log(data);
        
          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: data,
              success: function(){
                  fetchCart(sub_variant_id);
                  $("#mySizeChartModal").addClass('active-modal');
                  ebModal.style.display = "block";
                  //location.href="/checkout";
              }
          });
 })

function fetchCart(vid) {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            //onCartUpdate(cart);
            console.log('this is fetch cart');
            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = 'Cart is empty';
            } else {
                renderCart(cart,vid);
                $("#CartCount span").text(cart.item_count);
            }

        },
    });
}

function renderCart(cart,vid) {

    console.log('KKKK'+cart);

    clearCartDrawer();
  
  	var html = '';
  	console.log(cart.items);

    cart.items.forEach(function(item, index) {
      var qty = item.variant_title.split("/");
      if(vid == item.variant_id ){
      	//html+= '<div class="cart-item"><img src="'+item.image+'" alt="" width="200" height="200"><div class="content">'+item.title+'</div></div>';
         html+= '<div class="cart_content_popup"><div class="cart-msg"><span><svg class="icon icon-checkmark color-foreground-text" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path></svg></span>Item added to your cart</div><div class="ovrflow_crt"><div class="cart-item"><div class="product_image_cart"><img src="'+item.image+'" alt=""></div><div class="cntnt_qty_both"><div class="content">'+item.product_title+'</div><div class="qty">Quantity: '+qty[1]+'</div></div></div></div><div class="actions"><a class="btn text-cart" href="/cart"><i class="icon-basket"></i>View My Cart ('+cart.item_count+')</a><a class="btn" href="/checkout"><i class="icon-check"></i>Checkout</a><button type="button" class="link button-label cont_shop">Continue shopping</button></div></div>';
      }
    });
  	cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + html;
  	
}  

function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}  

  /* To Disable Inspect Element */
  /* $(document).bind("contextmenu",function(e) {
   e.preventDefault();
  });

  $(document).keydown(function(e){
      if(e.which === 123){
         return false;
      }

      if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)){
    return false;
  }
  if(e.ctrlKey && e.keyCode == 'S'.charCodeAt(0)){
    return false;
  }
  }); */

  $('#seller_plan_frequency_id').change(function() {
        var selectedText = $("#seller_plan_frequency_id option:selected").text(); // Get selected option text
        $(".delivery_frequency").text(selectedText + ", cancel anytime."); // Update text inside .delivery_frequency
  });
  $(".cart-add").click(function(e) {
        e.preventDefault(); // Prevent default anchor click behavior
        
        $("html, body").animate({
            scrollTop: $("#cartscroll").offset().top
        }, 1000); // Adjust the duration (800ms) for smooth scrolling
  });
  

});

function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

function changeurl(crnt_varr_id)
{
     //alert(crnt_varr_id);
     let url = window.location.href;
     var field = 'variant';
    
     if(url.indexOf('?' + field + '=') != -1)
     {
       console.log('? diye ache');
       let new_url= url.replace(/(variant=)[^\&]+/, '$1' + crnt_varr_id);
       window.history.pushState("data","",new_url);
     }
     else if(url.indexOf('&' + field + '=') != -1)
     {
       console.log('& diye ache');
       let new_url= url.replace(/(variant=)[^\&]+/, '$1' + crnt_varr_id);
       window.history.pushState("data","",new_url);
     }
     else
     {
       console.log('url e nei.');
       
       if (url.indexOf('?') !== -1) {
         console.log("The URL has query parameters.");
         let new_url=url+'&variant='+crnt_varr_id;
         window.history.pushState("data","",new_url);
       } else {
         console.log("The URL doesn't have any query parameters.");
         let new_url=url+'?variant='+crnt_varr_id;
         window.history.pushState("data","",new_url);
        }
       //let new_url=url+'?variant='+crnt_varr_id;
       //window.history.pushState("data","",new_url);
     }
	// var new_url="/webtricks/demo/demo_change-browser-url-without-refreshing-page-using-jquery-and-html5.php/"+url;
	// window.history.pushState("data","Title",new_url);
	// document.title=url;
}